import * as React from 'react';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps {
  status?: 'default' | 'error' | 'success';
  isDisabled?: boolean;
  children: any;
}

const FormItem = ({ status, isDisabled, children }: IProps): ReactElement => {
  const formItemClasses = twMerge(
    'form-item',
    status && `form-item--${status}`,
    isDisabled && 'disabled'
  );

  return <div className={formItemClasses}>{children}</div>;
};

export default FormItem;
